import React from 'react';
import PropTypes from 'prop-types';
import { Icon, Grid } from 'semantic-ui-react';
import { Link } from 'react-router';
import Moment from 'moment';
import Pager from 'react-pager';
import { dateFormats } from '../../../common/constants/dateFormats';
import LoaderHOC from '../../../common/HOC/LoaderHOC';
import styles from './EventChron.scss';

const EventChron = (props) => {
  const sortArrow = props.sortDir === 'DESC' ? 'triangle down' : 'triangle up';
  const dateFormat = dateFormats.MONTH_DAY_YEAR_AND_TIME_DISPLAY_FORMAT;

  const sortBy = props.sortByColumn !== '' ? props.sortByColumn : 'eventName';
  const sortEvents = (sortDir = 'ASC') =>
    props.filteredEvents.sort((a, b) => {
      if (!a[sortBy] || !b[sortBy]) {
        return;
      }

      return sortDir === 'ASC'
        ? a[sortBy].toString().toUpperCase() >
          b[sortBy].toString().toUpperCase()
          ? 1
          : -1
        : a[sortBy].toString().toUpperCase() <
          b[sortBy].toString().toUpperCase()
        ? 1
        : -1;
    });

  const sortedEvents = sortEvents(props.sortDir);

  const showAll =
    props.location && props.location.query && props.location.query.showall;

  const visibleEntries = showAll
    ? sortedEvents
    : sortedEvents.slice(
        props.currentPage * props.entriesPerPage,
        props.currentPage * props.entriesPerPage + props.entriesPerPage
      );

  const totalPages = showAll
    ? props.filteredEvents.length
    : Math.ceil(props.filteredEvents.length / props.entriesPerPage);

  return (
    <div
      id="test-events-table-container"
      className={styles['event-chron-container']}
    >
      <Grid className="listing">
        <Grid.Row className="test-table-header listing__header">
          <Grid.Column
            computer={6}
            className="test-name-header listing__column"
            onClick={() => props.sort('eventName')}
          >
            Name
            {props.sortByColumn === 'eventName' || props.sortByColumn === '' ? (
              <Icon className="test-sort-arrow" name={sortArrow} />
            ) : null}
          </Grid.Column>
          <Grid.Column
            computer={3}
            className="test-lookup-header listing__column"
            onClick={() => props.sort('lookupId')}
          >
            Lookup ID{' '}
            {props.sortByColumn === 'lookupId' ? (
              <Icon className="test-sort-arrow" name={sortArrow} />
            ) : null}
          </Grid.Column>
          <Grid.Column
            computer={3}
            className="test-venue-header listing__column"
            onClick={() => props.sort('venue')}
          >
            Venue
            {props.sortByColumn === 'venue' ? (
              <Icon className="test-sort-arrow" name={sortArrow} />
            ) : null}
          </Grid.Column>
          <Grid.Column
            computer={4}
            className="test-date-header listing__column"
            onClick={() => props.sort('sortableDate')}
          >
            Start Date
            {props.sortByColumn === 'sortableDate' ? (
              <Icon className="test-sort-arrow" name={sortArrow} />
            ) : null}
          </Grid.Column>
        </Grid.Row>
        {!props.isLoading && visibleEntries.length === 0 && (
          <Grid.Row>
            <Grid.Column
              computer={16}
              className="test-no-items-message listing__column"
            >
              No events found
            </Grid.Column>
          </Grid.Row>
        )}
        {visibleEntries.map((event) => {
          const noOrigTemplId =
            !event.originalTemplateId && 'has-no-original-template-id';
          return (
            <Grid.Row
              className={`test-item-row test-event-id-${event.id}`}
              key={event.aXSEvent ? event.aXSEvent.eventId : event.id}
            >
              <Grid.Column
                computer={6}
                className="listing__column listing__column--has-link test-item-name"
              >
                <Link
                  onClick={() => props.handleSelectEvent(event)}
                  className={`${noOrigTemplId} ${styles['event-link']} test-item-link`}
                >
                  {event.eventName}
                </Link>
              </Grid.Column>
              <Grid.Column
                computer={3}
                className={`listing__column test-item-lookupid ${styles['lookupid-small']}`}
              >
                {event.lookupId}
              </Grid.Column>
              <Grid.Column
                computer={3}
                className="listing__column test-item-venue"
              >
                {event.venue}
              </Grid.Column>
              <Grid.Column computer={4} className="listing__column">
                <span className="test-item-date">
                  {event.aXSEvent
                    ? Moment(event.aXSEvent.eventDateTime).format(dateFormat)
                    : Moment(event.startDate).format(dateFormat)}{' '}
                  {event.timeZone}
                </span>
              </Grid.Column>
            </Grid.Row>
          );
        })}
        {props.filteredEvents.length > props.entriesPerPage && !showAll && (
          <Grid.Row
            id="test-events-table-footer"
            className={styles['event-chron-footer']}
          >
            <Grid.Column textAlign="center" className="listing__column">
              <div data-pager-total-pages={totalPages}>
                <Pager
                  total={totalPages}
                  current={props.currentPage}
                  visiblePages={8}
                  titles={{ first: '<|', last: '>|' }}
                  onPageChanged={props.handlePageChange}
                  className="test-pagination"
                />
              </div>
            </Grid.Column>
          </Grid.Row>
        )}
      </Grid>
    </div>
  );
};

EventChron.propTypes = {
  isLoading: PropTypes.bool.isRequired,
  venue: PropTypes.string,
  venues: PropTypes.array,
  handlePageChange: PropTypes.func.isRequired,
  loadEvents: PropTypes.func.isRequired,
  sort: PropTypes.func.isRequired,
  sortByColumn: PropTypes.string.isRequired,
  sortDir: PropTypes.string.isRequired,
  currentPage: PropTypes.number.isRequired,
  entriesPerPage: PropTypes.number.isRequired,
  events: PropTypes.array.isRequired,
  filteredEvents: PropTypes.array,
  location: PropTypes.object,
};

export default LoaderHOC('isLoading', 'Events')(EventChron);



// WEBPACK FOOTER //
// ./src/routes/Events/components/EventChron.js